<template>
  <v-card class="card-border">
    <v-card-text>
      <v-data-table ref="dataTable" :headers="headers" :items="data" :search="search">
        <template v-slot:top>
          <v-row dense>
            <v-col cols="12" sm="12" md="4">
              <v-text-field v-model="search" label="Procurar..." prepend-inner-icon="mdi-magnify" />
            </v-col>
          </v-row>
        </template>

        <template
          v-slot:item.dataCriacao="{ item }"
        >{{ $functions.formatDateFirebase(item.dataCriacao.seconds) }}</template>

        <template v-slot:item.ativo="{ item }">
          <v-btn color="transparent" small fab depressed>
            <v-icon
              :color="item.ativo ? 'green' : 'red'"
            >{{ item.ativo ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.empresas="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="transparent"
                small
                fab
                v-on="on"
                depressed
                @click="$refs.dialogListEmpresas.show(item.empresas)"
              >
                <v-icon>mdi-domain</v-icon>
              </v-btn>
            </template>
            Empresas
          </v-tooltip>
        </template>
      </v-data-table>
      <DialogListEmpresas ref="dialogListEmpresas" />
    </v-card-text>
  </v-card>
</template>

<script>
import Sincronizacao from "@/services/sincronizacao";

export default {
  name: "Table",

  components: {
    DialogListEmpresas: () => import("./DialogListEmpresas")
  },

  data() {
    return {
      serviceSincronizacao: new Sincronizacao(),
      headers: [
        { text: "Descrição", value: "descricao" },
        { text: "Data Criação", value: "dataCriacao" },
        { text: "Ativo", value: "ativo", sortable: false, align: "center" },
        {
          text: "Empresas",
          value: "empresas",
          sortable: false,
          align: "center"
        }
      ],
      search: "",
      data: []
    };
  },

  async mounted() {
    try {
      this.data = await this.serviceSincronizacao.getAll();
    } catch (error) {
      this.$toast.error("Erro ao buscar as sincronizações");
    }
  }
};
</script>
